import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App"; // Pazi da se putanja poklapa ako si preimenovao u App.jsx

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
